import { render, staticRenderFns } from "./SubRequestForm.vue?vue&type=template&id=54d7c097&scoped=true&"
import script from "./SubRequestForm.vue?vue&type=script&lang=js&"
export * from "./SubRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7c097",
  null
  
)

export default component.exports